"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileUrl = void 0;
const getFileUrl = (path) => `https://storage.googleapis.com/set-live-stage.appspot.com${path}`;
exports.getFileUrl = getFileUrl;
